"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDistinctLanguages = exports.localizedString = exports.Locale = void 0;
var Locale;
(function (Locale) {
    Locale["EN"] = "en";
    Locale["EN_EU"] = "en-EU";
    Locale["EN_GB"] = "en-GB";
    Locale["EN_GB_OUTLET"] = "en-GB-OUTLET";
    Locale["EN_US"] = "en-US";
    Locale["EN_IE"] = "en-IE";
    Locale["EN_CA"] = "en-CA";
    Locale["FR_CA"] = "fr-CA";
    Locale["FR_FR"] = "fr-FR";
    Locale["EN_FR"] = "en-FR";
    Locale["DE_DE"] = "de-DE";
    Locale["EN_DE"] = "en-DE";
    Locale["IT_IT"] = "it-IT";
    Locale["EN_IT"] = "en-IT";
    Locale["ES_ES"] = "es-ES";
    Locale["EN_ES"] = "en-ES";
    Locale["NL_NL"] = "nl-NL";
    Locale["EN_NL"] = "en-NL";
    Locale["EN_AT"] = "en-AT";
    Locale["DE_AT"] = "de-AT";
    Locale["EN_BE"] = "en-BE";
    Locale["NL_BE"] = "nl-BE";
    Locale["FR_BE"] = "fr-BE";
    Locale["EN_CH"] = "en-CH";
    Locale["DE_CH"] = "de-CH";
    Locale["FR_CH"] = "fr-CH";
    Locale["IT_CH"] = "it-CH";
    Locale["EN_DK"] = "en-DK";
    Locale["EN_PL"] = "en-PL";
    Locale["EN_SM"] = "en-SM";
    Locale["IT_SM"] = "it-SM";
    Locale["EN_LU"] = "en-LU";
    Locale["FR_LU"] = "fr-LU";
    Locale["EN_EUROPE"] = "en-EUROPE";
    Locale["EN_SCAND"] = "en-SCAND";
})(Locale || (exports.Locale = Locale = {}));
function localizedString(value, locale = Locale.EN) {
    return {
        [locale]: value,
    };
}
exports.localizedString = localizedString;
function getDistinctLanguages() {
    const languages = Object.values(Locale).reduce((acc, locale) => {
        const language = locale.split('-')[0];
        return acc.includes(language) ? acc : [...acc, language];
    }, []);
    return languages;
}
exports.getDistinctLanguages = getDistinctLanguages;
//# sourceMappingURL=i18n.js.map